import { enableProdMode } from '@angular/core';

import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';
// eslint-disable-next-line @nx/enforce-module-boundaries
import pkg from '../../../package.json';
import project from '../project.json';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { sanitizeUrlForSentry, sanitizeBodyForSentry } from '@movinmotion/data-access-third-party';

if (environment.production) {
  enableProdMode();
}

if (['prod'].includes(environment.envName)) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.envName,
    release: `${project.name}@${pkg.version}`,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.breadcrumbsIntegration({
        // Désactivation de certaines options pour ne pas transmettre des données personnelles à Sentry
        console: false,
        dom: false,
        fetch: false,
        history: false,
        xhr: false,
        sentry: true,
      }),
    ],
    tracesSampleRate: 1.0,
    sendDefaultPii: false, // Désactivé pour ne pas transmettre des données personnelles à Sentry
    beforeSend(event) {
      if (event.request?.url) {
        event.request.url = sanitizeUrlForSentry(event.request.url);
      }

      if (event.request?.data) {
        event.request.data = sanitizeBodyForSentry(event.request.data);
      }
      return event;
    },
  });
}

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
